import { render, staticRenderFns } from "./TicketPreview.vue?vue&type=template&id=079fe8ca&scoped=true&"
import script from "./TicketPreview.vue?vue&type=script&lang=js&"
export * from "./TicketPreview.vue?vue&type=script&lang=js&"
import style0 from "./TicketPreview.vue?vue&type=style&index=0&id=079fe8ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079fe8ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VRow,VSimpleTable,VTooltip})
